export const env = {
  MODE: import.meta.env.MODE,
  VITE_DD_RUM_APPLICATION_ID: import.meta.env.VITE_DD_RUM_APPLICATION_ID,
  VITE_DD_RUM_CLIENT_TOKEN: import.meta.env.VITE_DD_RUM_CLIENT_TOKEN,
  VITE_ENABLE_VUE_QUERY_DEV_TOOLS: import.meta.env.VITE_ENABLE_VUE_QUERY_DEV_TOOLS,
  VITE_REPLENISHMENT_SUGGESTIONS: import.meta.env.VITE_REPLENISHMENT_SUGGESTIONS,
  VITE_REPLENISHMENT_DRAFTS: import.meta.env.VITE_REPLENISHMENT_DRAFTS,
  VITE_RELEASE_VERSION: import.meta.env.VITE_RELEASE_VERSION,
  VITE_KNOCK_API_KEY: import.meta.env.VITE_KNOCK_API_KEY,
  VITE_KNOCK_FEED_ID: import.meta.env.VITE_KNOCK_FEED_ID,
  VITE_PLAID_ENV: import.meta.env.VITE_PLAID_ENV,
  VITE_DATADOG_ENABLED: import.meta.env.VITE_DATADOG_ENABLED,
};
